module.exports = __webpack_public_path__ + "img/tc.1499ecfd.svg";